import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import { MissionDocument } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentList',
  props: {
    documents: null
  },
  emits: ["setActiveDocument", "togglePreviewable", "openAddFileModal"],
  setup(__props: any, { emit }) {

const tableClass = "text-left pl-0 font-size-14 font-weight-400 py-2"





const onViewDocument = (document: MissionDocument) => {
  emit("setActiveDocument", document)
  emit("togglePreviewable")
}

const onEditDocument = (document: MissionDocument) => {
  emit("setActiveDocument", document)
  emit("openAddFileModal")
}

return { __sfc: true,tableClass, emit, onViewDocument, onEditDocument, Icon, UserAvatar }
}

})